import request from '@/utils/request'
import qs from 'qs'
export function getList(query) {
    // console.log(store.state.headerSign)
    return request({
        url: '/store/api/cart/getList',
        method: 'get',
        params: query,
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}

export function toCollect(query) {
    // console.log(store.state.headerSign)
    return request({
        url: '/store/api/cart/moveCollect',
        method: 'post',
        data: qs.stringify(query),
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}
export function toDelGoods(query) {
    // console.log(query)
    return request({
        url: '/store/api/cart/del',
        method: 'delete',
        params: query,
        
        // headers: {
        //     'sign': store.state.headerSign
        // }
    })

}


// WEBPACK FOOTER //
// ./src/api/cart.js